<template>
    <div>
        <div v-if="data" class="flex justify-between items-center">
            <CircleIcon v-for="num in calculateCircleDepth(data, actual_depth)" class="w-6 h-6 mr-2 flex-shrink-0" :class="{'text-blue-200':subType == 'EMPLEADOS' || subType == 'MAQUINARIA','text-orange-200':subType == 'EMPRESA' || subType == 'SUBCONTRATAS'}" />
            <div class=" p-3 rounded-lg mb-2 flex justify-between w-full" :class="{'bg-blue-100':subType == 'EMPRESA2','bg-white':subType == 'EMPLEADOS' || subType == 'MAQUINARIA','bg-orange-100':subType == 'EMPRESA' || subType == 'SUBCONTRATAS'}">
                <div class="flex items-center leading-tight">
                    <FolderIcon class="w-6 h-6 mr-2 text-theme-11 flex-shrink-0" />
                    <span class="block px-4 text-xs">{{data.name}}</span>
                </div>
                <div v-if="data.allowFileUpload" class="flex flex-shrink-0 items-center">
                    <button title="No presentar" v-if="!data.files[data.order] || data.files[data.order] && !data.files[data.order].state" @click="noPresentar" class="flex hover:bg-orange-500 hover:border-orange-500 flex-shrink-0 justify-center ml-auto dropdown-toggle cursor-pointer button text-white border text-xs py-1 bg-theme-11 flex items-center relative mr-2">
                        <XOctagonIcon class="mr-0" />
                    </button>
                    <button v-if="!data.files[data.order] || data.files[data.order] && !data.files[data.order].state" @click="uploadFile(data)" class="w-48 flex hover:bg-orange-500 hover:border-orange-500 flex-shrink-0 justify-center ml-auto dropdown-toggle cursor-pointer button text-white border text-xs py-1 bg-theme-1 border-theme-1 flex items-center relative">
                        <UploadIcon class="mr-2" />
                        <AlertTriangleIcon v-if="!data.opcional_por_defecto" class="p-1 absolute top-0 right-0 -m-2 bg-orange-400 rounded-full" />
                        Subir documento
                    </button>
                    <a target="_blank" :href="data.files[data.order].urlForDownload" v-if="data.files[data.order] && (data.files[data.order].state == 1)" class="w-8 mr-2 p-1 flex flex-shrink-0 justify-center ml-auto dropdown-toggle cursor-pointer button text-white border text-theme-11 text-xs py-1 border-theme-11 flex items-center">
                        <EyeIcon />
                    </a>
                    <button v-if="data.files[data.order] && (data.files[data.order].state == 1 || data.files[data.order].state == 3)" @click="uploadFile" class="w-48 flex flex-shrink-0 justify-center ml-auto dropdown-toggle cursor-pointer button text-white border text-theme-11 text-xs py-1 border-theme-11 flex items-center">
                        <ClockIcon class="mr-2" />
                        Subido y Esperando
                    </button>
                    <a target="_blank" :href="data.files[data.order].urlForDownload" v-if="data.files[data.order] && data.files[data.order].state == 2" class="w-48 flex flex-shrink-0 justify-center ml-auto dropdown-toggle cursor-pointer button text-white border text-theme-9 text-xs py-1 border-theme-9 flex items-center">
                        <CheckIcon class="mr-2" />
                        Correcto
                    </a>
                </div>
            </div>
        </div>
        <div v-if="data && data.childs && data.childs.length">
            <carga-linea v-for="dat in data.childs" :data="dat" :subType="subType" :canEdit="canEdit" :actual_depth="actual_depth"></carga-linea>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import UploadFile from "@/components/UploadFile";

export default {
    name: "carga-linea",
    props: ["data", "index", "subType", "canEdit", "actual_depth"],
    data() {
        return {}
    },
    methods: {
        noPresentar() {
            console.log(this.data);
            window.bus.$emit("modalUploadFile", {
                files: this.data.files,
                fileName: this.data.name,
                tableName: this.data.tableName,
                fieldName: 'file',
                urlPath: '',
                filePath: '',
                recordNum: this.data.recordNum,
                info1: this.data.num, // Corresponde a la plantilla
                info2: 3, // Corresponde al estado.
                info3: 'No presenta', // Corresponde al motivo del estado.
                fecha_caducidad: this.data.fecha_caducidad ? '2100-01-01 00:00:00' : '',
                order: this.data.order, // Corresponde al índice de una repetición.
                config: {
                    rellena_fecha_caducidad: '2100-01-01 00:00:00'
                },
                autosave_file: true,
                callback: (files) => {
                    if (files) {
                        this.data.files = Object.keys(files).map((key) => { if (files[key] && files[key].state) files[key].state = "1"; return files[key]; });
                    } else {
                        this.data.files = {};
                    }
                }
            });
        },
        uploadFile(fileTemplate) {
            let reason = '';
            if(fileTemplate.files && fileTemplate.files[fileTemplate.order] && fileTemplate.files[fileTemplate.order].reason) {
                reason = fileTemplate.files[fileTemplate.order].reason;
            }
            window.bus.$emit("modalUploadFile", {
                files: this.data.files,
                fileName: this.data.name,
                tableName: this.data.tableName,
                fieldName: 'file',
                urlPath: '',
                filePath: '',
                recordNum: this.data.recordNum,
                info1: this.data.num, // Corresponde a la plantilla
                info2: 1, // Corresponde al estado.
                info3: reason, // Corresponde al motivo del estado.
                fecha_caducidad: this.data.files[this.data.order]?this.data.files[this.data.order]['fecha_caducidad']:'',
                order: this.data.order, // Corresponde al índice de una repetición.
                config: {
                    rellena_fecha_caducidad: this.data.fecha_caducidad
                },
                callback: (files) => {
                    if (files) {
                        this.data.files = Object.keys(files).map((key) => { if (files[key] && files[key].state) files[key].state = "1"; return files[key]; });
                    } else {
                        this.data.files = {};
                    }
                }
            });
        }
    }
}
</script>